import { faGlobe, faPalette, faTableList } from '@fortawesome/free-solid-svg-icons';
import { firstTabWithError as firstTabWithErrorGeneric } from 'modules/PublicCatalog/studio/inspectorTabs';
import i18n from 'i18n';

// The SUPPLIER inspector rail's tab model: which settings live in which tab.
//
// This is DATA, not UI, and it lives in its own module for two reasons: the
// page imports it to seed tab state and to route invalid submits (it should not
// have to import the component it renders just to read a constant), and its
// guard tests can then assert the field→tab map without mounting the whole rail
// (Radix, react-colorful, FontAwesome, the CN-code hover card).
//
// The map duplicates knowledge the zod schema also holds — deliberately: which
// tab a field belongs to is a UI grouping decision, not a validation one, so it
// does not belong in the schema. What keeps the two from drifting is
// SharePortalPage.test.js's exhaustiveness test: every editable schema field
// must route to exactly one tab. Add a field to the schema, add it here.
//
// `label` is an i18n GETTER, not a plain string: SharePortalPage.jsx (and its
// test) import this array directly at module scope — no hook/render context —
// so it has to stay a plain array of objects rather than become a buildX(t)
// factory. See CLAUDE.md i18n conventions — "getter pattern" for an export
// consumed by more than one file. `id` and `fields` are routing data, not
// copy, and stay plain strings.
export const INSPECTOR_TABS = [
  {
    id: 'publish',
    get label() {
      return i18n.t('freeSupplier:portalStudio.tabs.publish', 'Publish');
    },
    icon: faGlobe,
    fields: ['enabled', 'includeFutureRevisions', 'slug', 'passwordProtected', 'password'],
  },
  {
    id: 'content',
    get label() {
      return i18n.t('freeSupplier:portalStudio.tabs.content', 'Content');
    },
    icon: faTableList,
    fields: ['included', 'profileText', 'websiteUrl', 'contactEmail'],
  },
  {
    id: 'appearance',
    get label() {
      return i18n.t('freeSupplier:portalStudio.tabs.appearance', 'Appearance');
    },
    icon: faPalette,
    fields: ['logoUrl', 'labelsText'],
  },
];

// Supplier-bound wrapper over the shared, tab-model-agnostic router: an error
// on an unmapped field falls back to the first tab. Keeps the page + guard test
// call sites (`firstTabWithError(errors)`) unchanged after the shell extraction.
export const firstTabWithError = (errors = {}) => firstTabWithErrorGeneric(INSPECTOR_TABS, errors);
